export const ACTION_PREFIX = 'ACCOUNT_SELECTION';
export const PARTITION = 'accountSelection';

export const actionTypes = {
  GET_ACCOUNTS_PENDING: 'GET_ACCOUNTS_PENDING',
  GET_ACCOUNTS_FULFILLED: 'GET_ACCOUNTS_FULFILLED',
  GET_ACCOUNTS_REJECTED: 'GET_ACCOUNTS_REJECTED',
  GET_SUPPLIER_BUYER_ASSOCIATION_PENDING: 'GET_SUPPLIER_BUYER_ASSOCIATION_PENDING',
  GET_SUPPLIER_BUYER_ASSOCIATION_FULFILLED: 'GET_SUPPLIER_BUYER_ASSOCIATION_FULFILLED',
  GET_SUPPLIER_BUYER_ASSOCIATION_REJECTED: 'GET_SUPPLIER_BUYER_ASSOCIATION_REJECTED',
  SET_SELECTED_ACCOUNT: 'SET_SELECTED_ACCOUNT',
};
